export const TAXONOMY_PAGE_ARTICLES_PER_PAGE = 18;
export const landingPageTypes = {
  INTEREST: 'interest',
  PROGRAM: 'program',
};
export const landingPageCriteriaTypes = {
  INTEREST: 'area_of_interest',
  PROGRAM: 'program_type',
};
